import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { LevelResponse } from "../interface";

const fetchLevelData = async (
  orgId: string,
  subUserId: string
): Promise<LevelResponse> => {
  const { data } = await axiosInterceptor.get(
    `progression-b2b/${orgId}/${subUserId}/level`
  );
  return data;
};

const useStudentLevel = (orgId?: string, subUserId?: string) => {
  return useQuery({
    queryKey: ["userLevel", orgId, subUserId],
    queryFn: () => {
      if (!orgId || !subUserId)
        return Promise.reject("Missing orgId or subUserId");
      return fetchLevelData(orgId, subUserId);
    },
    enabled: !!orgId && !!subUserId,
  });
};

export default useStudentLevel;
